import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Icon from "components/library/Icon";

import styles from "./Checkbox.css";

export default class Checkbox extends Component {
  render() {
    return (
      <label
        className={classNames(styles.root, this.props.className, {
          [styles.disabled]: this.props.isDisabled,
          [styles.checked]: this.props.isChecked,
        })}
      >
        <input
          className={styles.checkbox}
          type="checkbox"
          checked={this.props.isChecked}
          disabled={this.props.isDisabled}
          onChange={this.props.onChange}
        />
        {!this.props.isDisabled ? (
          <Icon name="check" description="checkmark" className={styles.icon} />
        ) : null}
        <span className={classNames(styles.label, this.props.labelClassName)}>
          {this.props.label}
        </span>
      </label>
    );
  }
}

Checkbox.defaultProps = {
  isDisabled: false,
};

Checkbox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
};
